// import { link } from 'fs';
import * as constants from '../../constants';

const currentState = {
    leftNavigationLinks: [
        {
            title: 'Dashboard',
            hasChildren: false,
            link: '/dashboard',
            iconClass: 'site-menu-icon icon oi-dashboard',
            isActive: true
        },
        {
            title: 'Groups / Users',
            hasChildren: false,
            link: "/groups",
            iconClass: 'site-menu-icon icon oi-organization',
            isActive: false
        },

        {
            title: 'Meetings',
            hasChildren: false,
            link: '/meetings',
            iconClass: 'site-menu-icon fa fa-users',
            isActive: false
        },
        {
            title: 'Approvals',
            hasChildren: false,
            link: '/approvals',
            iconClass: 'site-menu-icon md-check-all',
            isActive: false
        },
        {
            title: 'Resources',
            hasChildren: false,
            link: "/resources",
            iconClass: 'site-menu-icon oi-file-submodule',
            isActive: false
        },
        {
            title: 'Evaluations',
            hasChildren: false,
            link: '/evaluations',
            iconClass: 'site-menu-icon icon ti-bar-chart-alt',
            isActive: false
        },
        {   
            title: 'Risks',
            hasChildren: false,
            link: '/risks',
            iconClass: 'site-menu-icon fa fa-cubes',
            isActive: false
        },
        {   
            title: 'Budgets',
            hasChildren: false,
            link: '/budgets',
            iconClass: 'site-menu-icon fa fa-cubes',
            isActive: false
        },
        {
            title: 'Compliance',
            hasChildren: false,
            link: '/compliance',
            iconClass: 'site-menu-icon icon fas fa-shield',
            isActive: false
        },
        // {   
        //     title: 'Discussions',
        //     hasChildren: false,
        //     link: '/discussions',
        //     iconClass: 'site-menu-icon ti-comments',
        //     isActive: false
        // },
        // {   
        //     title: 'Elections',
        //     hasChildren: false,
        //     link: '/elections',
        //     iconClass: 'site-menu-icon ti-check-box',
        //     isActive: false
        // }
        // {   
        //     title: 'Data Room',
        //     hasChildren: false,
        //     link: '/ddroom',
        //     iconClass: 'site-menu-icon icon ti-files',
        //     isActive: false
        // },
        // {   
        //     title: 'Settings',
        //     hasChildren: false,
        //     link: '/settings',
        //     iconClass: 'site-menu-icon md-tune',
        //     isActive: false
        // }
    ]
}

const reducer = (state = currentState, action) => {

    const clickedChildLinkParentIndex = (links, parentLinkTitle) => {
        return links.findIndex(link => {
            return link.title === parentLinkTitle;
        });
    };

    const allLinks = state.leftNavigationLinks.concat();
    let bachelorMutatedLinks = [];
    let marriedMutatedLinks = [];

    for (let link of allLinks) {
        if (link.hasChildren) {
            marriedMutatedLinks.push(link);
        } else {
            bachelorMutatedLinks.push(link);
        }
    }

    const clearActiveLinkStates = () => {
        for (const bachelorLink of bachelorMutatedLinks) {
            if (bachelorLink.isActive) {
                bachelorLink.isActive = false;
            }
        }
        for (const marriedLink of marriedMutatedLinks) {
            if (marriedLink.isActive) {
                marriedLink.isActive = false;
            }
        }
        for (const marriedLink of marriedMutatedLinks) {
            for (const childLink of marriedLink.theChildren) {
                if (!childLink.hasChildren) {
                    if (childLink.isActive) {
                        childLink.isActive = false;
                    }
                } else {
                    for (const grandchildLink of childLink.theChildren) {
                        if (grandchildLink.isActive) {
                            grandchildLink.isActive = false
                        }
                    }
                }
            }
        }
        return allLinks;
    };

    switch (action.type) {
        case constants.BACHELOR_LINK_CLICKED:

            clearActiveLinkStates();

            const clickedLinkIndex = linkTitle => {
                return bachelorMutatedLinks.findIndex(link => {
                    return link.title === linkTitle;
                });
            }

            bachelorMutatedLinks[clickedLinkIndex(action.payload.linkTitle)].isActive = true;

            return {
                leftNavigationLinks: allLinks
            }
        case constants.CHILD_LINK_CLICKED:

            clearActiveLinkStates();

            const clickedChildLinkIndex = childLinkTitle => {
                return marriedMutatedLinks[clickedChildLinkParentIndex(marriedMutatedLinks, action.payload.parentLinkTitle)].theChildren.findIndex(link => {
                    return link.title === childLinkTitle;
                });
            };

            marriedMutatedLinks[clickedChildLinkParentIndex(marriedMutatedLinks, action.payload.parentLinkTitle)].isActive = true;
            marriedMutatedLinks[clickedChildLinkParentIndex(marriedMutatedLinks, action.payload.parentLinkTitle)].theChildren[clickedChildLinkIndex(action.payload.childLinkTitle)].isActive = true;

            return {
                ...state,
                leftNavigationLinks: allLinks
            }
        case constants.GRAND_CHILD_LINK_CLICKED:

            clearActiveLinkStates();

            const clickedChildLinkGrandparentIndex = grandparentLinkTitle => {
                return marriedMutatedLinks.findIndex(link => {
                    return link.title === grandparentLinkTitle;
                });
            };
            const mutatedLinksChildren = marriedMutatedLinks[clickedChildLinkGrandparentIndex(action.payload.grandparentLinkTitle)].theChildren.concat();
            const mutatedLinksGrandchildren = mutatedLinksChildren[clickedChildLinkParentIndex(mutatedLinksChildren, action.payload.parentLinkTitle)].theChildren.concat();

            const clickedGrandchildLinkIndex = grandchildLinkTitle => {
                return mutatedLinksGrandchildren.findIndex(link => {
                    return link.title === grandchildLinkTitle;
                });
            };

            marriedMutatedLinks[clickedChildLinkGrandparentIndex(action.payload.grandparentLinkTitle)].isActive = true;
            mutatedLinksChildren[clickedChildLinkParentIndex(mutatedLinksChildren, action.payload.parentLinkTitle)].isActive = true;
            mutatedLinksGrandchildren[clickedGrandchildLinkIndex(action.payload.grandchildLinkTitle)].isActive = true;

            return {
                ...state,
                leftNavigationLinks: allLinks
            }
        default:
            return state;
    }

}

export default reducer;

